export default {
  props: ['show-cropper', 'show-filters', 'cropper-ready'],
  data() {
    return {
      activeFilter: null
    }
  },
  computed: {
    mobileCropperMenu() {
      return this.$store.getters.MOBILE_CROPPER_MENU;
    },
    mobileFilterMenu() {
      return this.$store.getters.MOBILE_FILTER_MENU;
    },
  },
  watch: {
    cropperReady() {
      if (this.drawing.photo.processing.filter) {
        this.setFilter(this.drawing.photo.processing.filter);
      }
    },
    mobileFilterMenu() {
      this.handleFilters();
    },
    showFilters() {
      this.handleFilters();
    }
  },
  methods: {
    handleFilters() {
      this.$nextTick(() => {
        this.filters.forEach(filter => {
          const el = this._.first(this.$refs[filter.name]);

          if (el) {
            this.applyFilter(el, filter);
          }
        });
      });
    },
    setFilter(filter, isMobile = false) {
      this.$store.dispatch('SET_MOBILE_FILTER_MENU', false);

      this.activeFilter = filter;

      if (isMobile) {
        this.$emit('set-filter', filter);
      }

      const previewEl = document.getElementById('preview');

      if (previewEl) {
        this.applyFilter(previewEl, filter);
      }
    },
    resetFilter() {
      this.setFilter(null);
    },
    back() {
      if (this.showCropper || this.showFilters) {
        this.$emit('hide-cropper');
        this.$emit('hide-filters');
      } else {
        this.$store.dispatch('SET_DRAWING', null);
      }
    },
  },
};
